__webpack_require__.p = "https://app.withvector1.com/";